import React, { createContext, useContext, useState, useEffect } from 'react';

const THEMES = [
  { id: 'rouge', nom: 'Rouge KD', couleur: '#C0392B', label: '🔴' },
  { id: 'bleu', nom: 'Bleu Marine', couleur: '#1A5276', label: '🔵' },
  { id: 'vert', nom: 'Vert Forêt', couleur: '#1E8449', label: '🟢' },
  { id: 'orange', nom: 'Orange Soleil', couleur: '#D35400', label: '🟠' },
  { id: 'violet', nom: 'Violet Royal', couleur: '#7D3C98', label: '🟣' },
  { id: 'noir', nom: 'Noir Élégant', couleur: '#1C2833', label: '⚫' },
  { id: 'teal', nom: 'Teal Moderne', couleur: '#0E7B73', label: '🩵' },
];

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [themeId, setThemeId] = useState(() => {
    return localStorage.getItem('theme') || 'rouge';
  });

  const theme = THEMES.find(t => t.id === themeId) || THEMES[0];

  const changerTheme = (id) => {
    setThemeId(id);
    localStorage.setItem('theme', id);
  };

  return (
    <ThemeContext.Provider value={{ theme, themeId, changerTheme, THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}

export { THEMES };
